import { Component, Input, OnInit, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmployerVerificationData, ReferenceVerificationData } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { FileTransferPayload } from 'src/app/models/FileTransferPayload';
import { ScreeningService } from '../../services/screening.service';
import { ScreeningDraftService } from '../../services/screening-draft.service';
import { NgForm } from '@angular/forms';
import { take, tap, switchMap, retry, filter } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { EmploymentDataComponent } from 'src/app/shared-components-module/employment-data/employment-data.component';
import { ResidentDataComponent } from 'src/app/shared-components-module/resident-data/resident-data.component';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { SearchPackage } from 'src/app/packages-module/models/searchPackage';

@Component({
  selector: 'app-create-additional-data',
  templateUrl: './create-additional-data.component.html',
  styleUrls: ['./create-additional-data.component.less']
})
export class CreateAdditionalDataComponent implements OnInit, AfterViewInit {

  public get employmentData() : EmployerVerificationData {
    if(!this.drafts.directOrderDemographics.employmentData){
      this.drafts.directOrderDemographics.employmentData = new EmployerVerificationData();
    }
    return this.drafts.directOrderDemographics.employmentData;
  }
    
  public get residentData() : ReferenceVerificationData {
    if(!this.drafts.directOrderDemographics.referenceData){
      this.drafts.directOrderDemographics.referenceData = new ReferenceVerificationData();
    }
    return this.drafts.directOrderDemographics.referenceData;
  }
  
  loading : boolean = true;
  fileTransfer: FileTransferPayload = new FileTransferPayload();
  @Output() public phaseComplete: EventEmitter<number> = new EventEmitter();
  @ViewChild(EmploymentDataComponent,{}) empForm: EmploymentDataComponent;
  @ViewChild(ResidentDataComponent,{}) resForm: ResidentDataComponent;
  @ViewChild('appData', {}) ngForm: NgForm;
  selectedPkg : SearchPackage

  constructor(private toastr: ToastrService, private screening: ScreeningService, public drafts : ScreeningDraftService,public packages : SearchPackageService) { }

  ngOnInit() {
    // Load all the data for this draft if there is any.
    forkJoin([this.drafts.FetchEmploymentDataForDraft(),this.drafts.FetchReferenceDataForDraft(),this.drafts.FetchSupportingDocsForDraft(),this.packages.FetchSearchPackageById(this.drafts.directOrderDemographics.searchPackageId)]).subscribe(results =>{
      this.drafts.directOrderDemographics.employmentData = results[0];
      this.drafts.directOrderDemographics.referenceData = Object.assign(new ReferenceVerificationData(),results[1]);
      this.drafts.directOrderDemographics.docs = results[2];
      this.selectedPkg =  Object.assign(new SearchPackage(),results[3][0]);
    },(err: any)=>{
      this.toastr.error('Error loading additional data for draft')
    },()=> {this.loading = false;});
  }

  ngAfterViewInit(): void {  }

  saveEmp(){
    if (this.empForm.form.valid && this.empForm.form.dirty) {
      this.employmentData.screeningDraftId = this.drafts.directOrderDemographics.id;
      this.drafts.SaveEmploymentVerification(this.employmentData).pipe(
        take(1),
        tap(_=>{ this.drafts.directOrderDemographics.employmentData = _}))
      .subscribe(()=>{
        this.toastr.success('Employment Data saved');
      },(err: any) => {
        this.toastr.error('Error saving verification data.');
      });
    }
  }

  saveRes(){
    if (this.resForm.form.valid && this.resForm.form.dirty) {
      this.residentData.screeningDraftId = this.drafts.directOrderDemographics.id;
      this.residentData.startDate = this.residentData.startDateString;
      this.drafts.SaveResVerification(this.residentData).pipe(
        take(1),
        tap(_=>{ 
          this.drafts.directOrderDemographics.referenceData = Object.assign(new ReferenceVerificationData(),_);
          this.drafts.directOrderDemographics.referenceData.startDate = this.drafts.directOrderDemographics.referenceData.startDateString;
        }))
      .subscribe(()=>{
        this.toastr.success('Residence Data saved');
        console.log(this.residentData);
      },(err: any) => {
        this.toastr.error('Error saving verification data.');
      });
    }
  }

  public trySaveVerificationData() {
    
    if(this.empForm)this.saveEmp();
    if(this.resForm)this.saveRes();
    
    if(this.empForm && !this.empForm.form.valid ||  this.resForm && !this.resForm.form.valid) return;

    if(this.drafts.directOrderDemographics.docs && this.drafts.directOrderDemographics.docs.length > 0){
      this.continue();
    }else{
      this.toastr.error('Please supply income verification documentation, and a signed rental application for your applicant.', 'Applicant Documentation Required!',{ disableTimeOut: true, closeButton: true })
    }    
  }

  continue(){
    if(this.drafts.directOrderDemographics.lastCompletedPhase <3){
      this.drafts.directOrderDemographics.lastCompletedPhase = 3;
      this.drafts.SaveDraft(this.drafts.directOrderDemographics).pipe(take(1), tap(_=>{
        Object.assign(this.drafts.directOrderDemographics,_);
      })).subscribe(null,()=>{
        // this.toastr.error('There was an error saving your position.', 'Draft update error');
      },
      ()=>{
        this.phaseComplete.next(3);
      });
    }else{
      this.phaseComplete.next(3);

    }
  }

  back(){
    this.phaseComplete.next(1);
  }

}
